import type { GridSortModel } from "@mui/x-data-grid-premium";
import type { UrlSortModel } from "src/system/useResourceList/useResourceList.types.ts";

export const convertGridSortModelToUrlSortModel = (model: GridSortModel) => {
  return model.reduce((acc, item) => {
    return {
      ...acc,
      [item.field]: item.sort,
    };
  }, {} as UrlSortModel);
};
